import React from 'react';
import SectionHeading from '../Typography/SectionHeading/SectionHeading';
import EditButton from '../Typography/EditButton/EditButton';
import {
  customerSummaryLine1,
  customerSummaryLine2,
  customerSummaryLine3
} from './util';
import styles from './style.css';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const ReviewCombinedPersonalInformation = ({ customer, handleClick }) => (
  <div className="review-customer-information">
    <div className="section-header">
      <SectionHeading text="My Information">
        <EditButton onClick={handleClick('info')} currentlyEditing={false} />
      </SectionHeading>
    </div>
    <div className="customer-information-lines">
      <div
        data-name={generateGeneralTestID('Review', 'AccountOwnerSummaryLine1')}>
        {customerSummaryLine1(customer)}
      </div>
      <div
        data-name={generateGeneralTestID('Review', 'AccountOwnerSummaryLine2')}>
        {customerSummaryLine2(customer)}
      </div>
      <div
        data-name={generateGeneralTestID('Review', 'AccountOwnerSummaryLine3')}
        className="nasu_masking_class">
        {customerSummaryLine3(customer)}
      </div>
    </div>
    <style jsx>{styles}</style>
  </div>
);

export default ReviewCombinedPersonalInformation;
